var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"monthMoneyEcharts",staticClass:"center",staticStyle:{"width":"95%","height":"95%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }